const wrapperCls = "_vcw1pu65ij";

export { wrapperCls };
import "./video-component.wrapper.style.linaria.module.css";
//# sourceMappingURL=video-component.wrapper.style.js.map
